

const Tools = () => {
    return (<>
        <div>Tools go here</div>
    </>)
}

export default Tools;